export enum TimeInForceEnum {
  EndOfDay = 'Day',
  ExtendedHours = 'ExtendedDay',
  // TODO: To be checked with SOR values - check SOROrderTimeInForce enum in 'store/gateway/types.ts'
  GTC = 'GTC',
  GTD = 'Gtd',
}
